const pointerScroll = {
  watch: {
    typeAheadPointer () {
      this.maybeAdjustScroll()
    }
  },

  methods: {
    /**
     * Adjust the scroll position of the dropdown list
     * if the current pointer is outside of the
     * overflow bounds.
     * @returns {*}
     */

    maybeAdjustScroll () {
      if (this.typeAheadPointer === 0) {
        return this.scrollTo(0)
      }

      const pixelsToPointerTop = this.pixelsToPointerTop()
      const pixelsToPointerBottom = this.pixelsToPointerBottom()
      const viewport = this.viewport()

      if (pixelsToPointerTop <= viewport.top) {
        return this.scrollTo(pixelsToPointerTop)
      } else if (pixelsToPointerBottom >= viewport.bottom) {
        return this.scrollTo(viewport.top + this.pointerHeight())
      }
      return null
    },

    /**
     * The distance in pixels from the top of the dropdown
     * list to the top of the current pointer element.
     * @returns {number}
     */
    pixelsToPointerTop () {
      let pixelsToPointerTop = 0
      if (this.$refs.labelCloud) {
        pixelsToPointerTop += this.$refs.labelCloud.$el.offsetHeight
      }

      if (this.$refs.dropdownMenu) {
        for (let i = 0; i < this.typeAheadPointer; i++) {
          pixelsToPointerTop += this.$refs.dropdownMenu.children[parseInt(i)].offsetHeight
        }
      }
      return pixelsToPointerTop
    },

    /**
     * The distance in pixels from the top of the dropdown
     * list to the bottom of the current pointer element.
     * @returns {*}
     */
    pixelsToPointerBottom () {
      return this.pixelsToPointerTop() + this.pointerHeight()
    },

    /**
     * The offsetHeight of the current pointer element.
     * @returns {number}
     */
    pointerHeight () {
      const element = this.$refs.dropdownMenu ? this.$refs.dropdownMenu.children[this.typeAheadPointer] : false
      return element ? element.offsetHeight : 0
    },

    /**
     * The currently viewable portion of the dropdownMenu.
     * @returns {{top: (string|*|number), bottom: *}}
     */

    viewport () {
      return {
        top: this.$refs.dropdownContent ? this.$refs.dropdownContent.scrollTop : 0,
        bottom: this.$refs.dropdownContent ? this.$refs.dropdownContent.offsetHeight + this.$refs.dropdownContent.scrollTop : 0
      }
    },

    /**
     * Scroll the dropdownMenu to a given position.
     * @param position
     * @returns {*}
     */
    scrollTo (position) {
      if (this.$refs.dropdownContent) {
        this.$refs.dropdownContent.scrollTop = position
      }
    }
  }
}

export default pointerScroll
